import React, { useState, useEffect } from 'react';
import { getDevEmitter, dev_event } from './devEvents';

/**
 * Saves level recording into a store.
 * levelKey: {
 * 	recordings: [{
 * 		name: string,
 * 		presses: String[]
 * }]
 * }
 */

export const Recorder = () => {
  const [currentRecording, setRecording] = useState([]);
  const [playingState, setPlayingState] = useState(false);
  const [currentLevel, setCurrentLevel] = useState('');
  const [canFinishRecording, setCanFinishRecording] = useState(false);
  getDevEmitter()?.on(dev_event.SAVE_RECORDING, (recording) => {
    setRecording(recording);
  });

  getDevEmitter()?.on(dev_event.LEVEL_TRACKER, (levelName) => {
    setPlayingState(false);
    setCurrentLevel(levelName);
  });

  useEffect(() => {
    if (currentLevel !== '') {
      (async () => {
        const recording = await (
          await fetch(`/api/post-recording/${currentLevel}`)
        ).json();
        console.log('recording: ', currentLevel, recording);
        if (Array.isArray(recording)) {
          setRecording(recording);
        } else {
          setRecording([]);
        }
      })();
    }
  }, [currentLevel]);

  return (
    <div className="replay-test-module">
      <h3>Level: {currentLevel}</h3>
      <p>
        {currentRecording.length > 0
          ? 'Recording Loaded...'
          : 'Automatically recording...'}
      </p>
      {!playingState ? (
        <button
          disabled={currentRecording.length === 0 || currentLevel === ''}
          onClick={() => {
            getDevEmitter()?.emit(dev_event.PLAY_Recording, currentRecording);
            setPlayingState(true);
          }}
        >
          Play Recording
        </button>
      ) : (
        <p>Playing....</p>
      )}
    </div>
  );
};
